import { UiButtonComponent } from '@/ui/button/ui-button';
import { translate } from '@/utils/i18n/translate.reactive-helpers';
import { Component, inject, output, signal, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import {
    type AdvizeoModalButton,
    type AdvizeoModalComponent,
    injectAdvizeoModalInput
} from '../../../../components/advizeo-modal-spawner/advizeo-modal-spawner.component';
import { PeriodIdentifier } from '../../../../constants/period.constant';
import type { ClassificationNodeId } from '../../../../interfaces/Classification.interface';
import { ClassificationNodeNamePipe } from '../../../../pipes/classification-node-name.pipe';
import { TranslatePeriodPipe } from '../../../../pipes/translate-period.pipe';
import { InformationProvider } from '../../../../providers/information/information.provider';
import type { ReportGenerationDescription } from '../../reports.interface';
import { ReportsService } from '../../services/reports.service';

export interface DashboardExportPopoverComponentInput {
    period: number;
    enableEstimated: boolean;
    report: ReportGenerationDescription;
    classificationNodeId: ClassificationNodeId;
}
@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./dashboard-export-popover.scss'],
    selector: 'dashboard-export-popover',
    templateUrl: 'dashboard-export-popover.html',
    imports: [UiButtonComponent, TranslatePipe, TranslatePeriodPipe, ClassificationNodeNamePipe]
})
export class DashboardExportPopoverComponent implements AdvizeoModalComponent<DashboardExportPopoverComponentInput, String> {
    private _reportsProvider = inject(ReportsService);
    private _informationProvider = inject(InformationProvider);

    title = translate('POPOVERS.EXPORT_DASHBOARD.TITLE');
    isDismissable = signal(true);
    generatingReport: boolean = false;
    buttons = signal<AdvizeoModalButton[]>([]);

    lastTwelveMonths = PeriodIdentifier.LAST_TWELVE_MONTHS;

    close = output<String | undefined>();
    input = injectAdvizeoModalInput<{
        period: number;
        enableEstimated: boolean;
        report: ReportGenerationDescription;
        classificationNodeId: ClassificationNodeId;
    }>();

    validate() {
        this.generatingReport = true;
        try {
            this._reportsProvider
                .generateReportOneShot(
                    this.input().period,
                    this.input().enableEstimated,
                    this.input().report,
                    this.input().classificationNodeId
                )
                .then(url => {
                    this.generatingReport = false;
                    this.close.emit(url);
                })
                .catch(() => {
                    this.generatingReport = false;
                    this._informationProvider.showToast('POPOVERS.EXPORT_DASHBOARD.ERROR', 'error');
                });
        } catch (e) {
            this.generatingReport = false;
            this._informationProvider.showToast('POPOVERS.EXPORT_DASHBOARD.ERROR', 'error');
        }
    }
}
